export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-medium-fbca6526b00c07e0d3ace52711255e16.eot";